import { CircularProgress } from "@mui/material";

interface LoadingButtonProps {
  isLoading: boolean;
  disabled?: boolean;
  onClick?: () => void;
  ButtonComponent: React.ElementType;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  [key: string]: any;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  disabled,
  onClick,
  ButtonComponent,
  style,
  children,
  ...buttonProps
}) => {
  return (
    <ButtonComponent
      disabled={isLoading || disabled}
      variant="contained"
      style={{ marginTop: "20px", marginRight: "20px", ...style }}
      onClick={onClick}
      {...buttonProps}>
      {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
      {children}
    </ButtonComponent>
  );
};
